import { useCompanyId } from 'modules/app/hooks/useCompanyId';
import {
  useMutation,
  type MutationState,
} from 'src/core/api/hooks/useMutation';

import {
  useInvalidateSpanishDprSettingsQueryCache,
  useUpdateSpanishDprSettingsQueryCache,
} from './useSpanishDprSettings';

export type Payload = {
  fiscalYearEndMonth: number;
  fiscalYearEndDay: number;
};

type RawData = object;

type Result = RawData;

export const useSetSpanishDprSettings = (): MutationState<Payload, Result> => {
  const companyId = useCompanyId();

  const invalidateSpanishDprSettingsQueryCache =
    useInvalidateSpanishDprSettingsQueryCache();

  const updateSpanishDprSettingsQueryCache =
    useUpdateSpanishDprSettingsQueryCache();

  return useMutation<Payload, Result, RawData>({
    request: {
      type: 'rest',
      target: 'companyAPI',
      method: 'post',
      endpoint: '/bookkeeping/spanish-dpr/settings',
    },
    reshapeData: (data) => {
      return data;
    },
    options: {
      onSuccess: ({ payload }): void => {
        updateSpanishDprSettingsQueryCache(payload);
        invalidateSpanishDprSettingsQueryCache(companyId);
      },
    },
  });
};
